import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Shop from './pages/Shop';
import ShopBook from './pages/ShopBook';
import Dashboard from './pages/Dashboard';
import BookForm from './pages/BookForm';
import UserManagement from './pages/UserManagement';
import ClientManagement from './pages/ClientManagement';
import DocumentTypes from './pages/DocumentTypes';
import OrderManagement from './pages/OrderManagement';
import AdminLayout from './components/AdminLayout';
import MasterManagement from './pages/MasterManagement';
import {
  getAuthToken,
  getAllSubjects,
  createSubject,
  updateSubject,
  deleteSubject,
  getAllClasses,
  createClassLevel,
  updateClassLevel,
  deleteClassLevel,
} from './utils/api';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = getAuthToken();
  return token ? <AdminLayout>{children}</AdminLayout> : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:id" element={<ShopBook />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/books/new"
          element={
            <PrivateRoute>
              <BookForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/books/:id"
          element={
            <PrivateRoute>
              <BookForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <UserManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <PrivateRoute>
              <ClientManagement />
            </PrivateRoute>
          }
        />
        <Route
          path="/document-types"
          element={
            <PrivateRoute>
              <DocumentTypes />
            </PrivateRoute>
          }
        />
        <Route
          path="/subjects"
          element={
            <PrivateRoute>
              <MasterManagement
                title="Subjects"
                itemLabel="Subject"
                loadItems={getAllSubjects}
                createItem={createSubject}
                updateItem={updateSubject}
                deleteItem={deleteSubject}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/classes"
          element={
            <PrivateRoute>
              <MasterManagement
                title="Classes"
                itemLabel="Class"
                loadItems={getAllClasses}
                createItem={createClassLevel}
                updateItem={updateClassLevel}
                deleteItem={deleteClassLevel}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <PrivateRoute>
              <OrderManagement />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
